import catalog from "../assets/cb_items.json";

export interface CbItem {
    key: string;
    identifier: string;
    displayName: string;
    type: "block" | "item";
    jarId: number;
    wireId: number;
    replacement: string | null;
}

const byWireId = new Map<number, CbItem>((catalog as CbItem[]).map((e) => [e.wireId, e]));

export function cbItemByWireId(itemId: number): CbItem | undefined {
    return byWireId.get(itemId);
}
